// Utility to encode/decode a compact roomId from roomId + hostId
export function encodeRoomId(roomId, hostId) {
  const raw = `${roomId}:${hostId}`;
  return btoa(unescape(encodeURIComponent(raw)));
}
export function decodeRoomId(id) {
  try {
    const raw = decodeURIComponent(escape(atob(id)));
    const [roomId, hostId] = raw.split(':');
    return { roomId, hostId };
  } catch (e) {
    return { roomId: null, hostId: null };
  }
}
